<div *ngIf="serverResponse()" class="row">
  <div class="col-12">
    <app-server-response [response]="serverResponse()"></app-server-response>
  </div>
</div>
<div class="mb-4 mt-4">
  <div class="card-header" style="border: 1px solid #e4e4e4;">
    <h2 class="text-center m-0">{{ "CASES.single.fund_balances.title" | translate }}</h2>
  </div>
  <div class="card-body p-0">
    <div class="mat-elevation-z5" style="border: 1px solid rgba(0, 0, 0, 0.12); border-top: none">
      <table style="width: 100%" mat-table [dataSource]="dataSource()">

        <ng-container matColumnDef="occurred_at">
          <th mat-header-cell *matHeaderCellDef>{{ "CASES.single.fund_balances.date" | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.occurred_at | toDateObject | date: 'medium' }}</td>
        </ng-container>

        <ng-container matColumnDef="entry_type">
          <th mat-header-cell *matHeaderCellDef>{{ "CASES.single.fund_balances.entry_type" | translate }}</th>
          <td mat-cell *matCellDef="let element">
            {{ "CASES.single.fund_balances.entry_types." + element.entry_type | translate }}
            <ng-container *ngIf="element.payment_plan_type?.name"> ({{ element.payment_plan_type.name }})</ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>{{ "CASES.single.fund_balances.amount" | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.amount | currency: 'EUR' }}</td>
        </ng-container>

        <ng-container matColumnDef="running_balance">
          <th mat-header-cell *matHeaderCellDef>{{ "CASES.single.fund_balances.running_balance" | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.running_balance | currency: 'EUR' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="ledger-row"
            [class.selected-row]="selectedEntry()?.id === element.id"
            [class.related-row]="selectedEntry()?.id !== element.id && relatedEntryIds().has(element.id)"
            (click)="toggleEntry(element)">
        </tr>
      </table>

      <div *ngIf="isLoading()" class="text-center" style="padding: 50px">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div *ngIf="!isLoading() && !hasData()">
        <h3 class="text-center pt-3">{{ "CASES.single.fund_balances.no_data" | translate }}</h3>
      </div>

      <div class="d-flex justify-content-end align-items-center px-2 py-1">
        <button type="button" class="btn btn-link p-0" (click)="toggleShowAll()">
          {{ (showAll() ? "CASES.single.fund_balances.show_paginated" : "CASES.single.fund_balances.show_all") | translate }}
        </button>
      </div>

      <mat-paginator *ngIf="!showAll()"
                     [length]="paginatorConfig().length"
                     [pageIndex]="paginatorConfig().pageIndex"
                     [pageSize]="paginatorConfig().pageSize"
                     [pageSizeOptions]="[5, 10, 20]"
                     (page)="paginatorChange($event)"
                     showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
</div>
